// TODO: consider to move this enum into component file once we migrate it on TypeScript or replace with some common enum
export enum InfoPresentation {
  POPOVER = 'POPOVER',
  MODAL = 'MODAL',
}
